import { ZoomInfoResponse } from '~/common/types';

const ZOOM_INFO_FIELD_MAP: Array<{ key: keyof ZoomInfoResponse; field: string }> = [
  { key: 'hasFirstName', field: 'firstname' },
  { key: 'hasLastName', field: 'lastname' },
  { key: 'hasJobTitle', field: 'jobtitle' },
  { key: 'hasCompanyName', field: 'companyname' },
  { key: 'hasCompanyEmployeeCount', field: 'companyemployeecount' },
];

export const getWebEnrichedFields = (zoomInfoData: ZoomInfoResponse): string =>
  ZOOM_INFO_FIELD_MAP.filter(({ key }) => !!zoomInfoData?.[key])
    .map(({ field }) => field)
    .join(',');
